import { T, wedgeVar, type TokenName } from '@territory/tokens';

interface WedgeRoleOptions {
  /* Preserve serialized legacy declarations when a shipped selector matches that exact string. */
  exactLegacy?: boolean;
}

/* Read legacy roles at the component, so local overrides precede the inherited library aliases. */
export const wedgeRole = (
  name: TokenName,
  fallback: string | number = T[name],
  options: WedgeRoleOptions = {},
): string => options.exactLegacy ? `var(${wedgeVar(name)})` : `var(${wedgeVar(name)}, ${fallback})`;

/* Keep exact declarations for shipped selectors that match serialized role values. */
export const wedgeExactRole = (name: TokenName): string =>
  wedgeRole(name, undefined, {exactLegacy: true});
